/**
 * JmPayDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import JmPayDashboardPresenter from './JmPayDashboardPresenter';
import MessageAlert from 'utils';
import { JmPayApi, UserApi } from 'api';
// import dayjs from 'dayjs';
import moment from 'moment';

const MOMENT_FORMAT = 'YYYY-MM-DD';
const endDate = moment().format(MOMENT_FORMAT);
const startDate = moment().add(-30, 'days').format(MOMENT_FORMAT);

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const JmPayDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [loading, setLoading] = useState(false);

  const [dateRange, setDateRange] = useState({
    startDate,
    endDate,
    keyword: null,
  });
  const [userData, setUserData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderData_date, setOrderData_date] = useState([]);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 유저데이터 조회
   * --
   */
  const getUserData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await UserApi.getUsers({
        // filter: 'jm_pay_setting',
        filter: 'jm_pay',
        join_tables: `["grade"]`,
      });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setUserData(data);
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[JmPayDashboardContainer][getUserData] Error: ', e);
      MessageAlert.error(e.message);
    }
  };
  /**
   * 사용데이터 조회
   * --
   */
  const getOrderData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await JmPayApi.getJmPays({
        join_tables: `["user"]`,
        start_date: moment(dateRange.startDate).startOf('day').unix(),
        end_date: moment(dateRange.endDate).endOf('day').unix(),
      });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setOrderData(data);
        setOrderData_date(() => {
          return data.reduce((acc, item) => {
            // UNIX 타임스탬프를 Date 객체로 변환
            const date = new Date(item.created_at * 1000);

            // 날짜를 'YYYY-MM-DD' 형식으로 변환
            const dateKey = date.toISOString().split('T')[0];

            // 같은 날짜에 해당하는 데이터를 그룹화
            if (!acc[dateKey]) {
              acc[dateKey] = [];
            }
            acc[dateKey].push(item);
            return acc;
          }, {});
        });
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[JmPayDashboardContainer][getUserData] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getUserData();
    getOrderData();
  }, []);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <JmPayDashboardPresenter
        {...{
          loading,
          userData,
          orderData,
          orderData_date,
        }}
      />
    </>
  ); // JSX: end
};

JmPayDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default JmPayDashboardContainer;
